import { TenantEntity } from '../TenantEntity'

export class UnitLoadDeviceUsage extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get isDirty() {
    return this._data.isDirty
  }
  set isDirty(isDirty) {
    this._data.dirty = isDirty
  }
  // =====================非db 字段，关联的装箱信息============
  get unitLoadDevice() {
    return this._data.unitLoadDevice
  }
  set unitLoadDevice(unitLoadDevice) {
    this._data.unitLoadDevice = unitLoadDevice || []
  }
  // =====================db 字段，关联的装箱信息============
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get unitLoadDeviceUuid() {
    return this._data.unitLoadDeviceUuid
  }
  set unitLoadDeviceUuid(unitLoadDeviceUuid) {
    this._data.unitLoadDeviceUuid = unitLoadDeviceUuid
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage
  }
  get cargoName() {
    return this._data.cargoName
  }
  set cargoName(cargoName) {
    this._data.cargoName = cargoName
  }
  get palletRequirement() {
    return this._data.palletRequirement
  }
  set palletRequirement(palletRequirement) {
    this._data.palletRequirement = palletRequirement
  }
  get cabinRequirement() {
    return this._data.cabinRequirement
  }
  set cabinRequirement(cabinRequirement) {
    this._data.cabinRequirement = cabinRequirement
  }
  get size() {
    return this._data.size
  }
  set size(size) {
    this._data.size = size
  }
  get serialNo() {
    return this._data.serialNo
  }
  set serialNo(serialNo) {
    this._data.serialNo = serialNo
  }
}
